import axios from 'axios';

export const AWARDS_RECEIVED = 'AWARDS_RECEIVED';

const getAwardsForProduct = (teamId, productId) => (
  (dispatch) => {
    axios.get(`/api/teams/${teamId}/products/${productId}/awards`)
      .then((response) => {
        dispatch({
          type: AWARDS_RECEIVED,
          productId,
          awards: response.data.data,
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      });
  }
);

export default getAwardsForProduct;
